// extracted by mini-css-extract-plugin
export default {"container":"an-z","blurb":"bn-z","links":"cn-z"};